module.exports = __webpack_public_path__ + "static/media/card-blog13.95305486.jpg";